<template>
  <router-view></router-view>
</template>

<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      "gates": [
        {
          "gate": 13, // the number for the gate
          "waterUsagePattern": [
            {
              'pattern': 'single',
              'runningTime': 4320,  // 72 hr
              'totalShares': 0,
              'shareDuration': 0
            },{
              'pattern': 'double',
              'runningTime': 0, // 0 hr
              'totalShares': 0, // total of active shares in the gate
              'shareDuration': 0 // how long a cycle lasts per water purchase in minutes
            },
          ],
          "shareDuration": 0, // how long a single share is in minutes
          "programDuration": 1, // number of weeks in the season
          "programStart": new Date(2026, 9, 22, 18, 0, 0), // First date of the program
          "startsOnDouble": false,
          "gateCalendar": [], // JSON array of calendar entries
        },
        {
          "gate": 14,
          "waterUsagePattern": [
            {
              'pattern': 'single',
              'runningTime': 2880, // 48 hr
              'totalShares': 0, 
              'shareDuration': 0
            },
            {
              'pattern': 'double',
              'runningTime': 0, // 0 hr
              'totalShares': 0,
              'shareDuration': 0
            }
          ],
          "programDuration": 1,
          "programStart": new Date(2026, 9, 8, 18, 0, 0),
          "startsOnDouble": false,
          "gateCalendar": [],
        }
      ],
      "participants": [
        { 
          'id': 'EBIC2',
          'firstName': 'Marianne', 
          'lastName': 'DeLany', 
          'shareCount': 1, // Note: she only has 1 share but is getting an extra half per Bev on 10/7/25
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC1',
          'firstName': 'Michael', 
          'lastName': 'Wyatt', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC4',
          'firstName': 'Shaun', 
          'lastName': 'Barney', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC3',
          'firstName': 'Todd', 
          'lastName': 'O\'Neal', 
          'shareCount': 2.5, //0.5 from Dixie Cowley, 1 from Elsinore
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        // { 
        //   'id': 'EBIC6',
        //   'firstName': 'Brent', 
        //   'lastName': 'Salisbury', 
        //   'shareCount': 0.5,
        //   'turnLength': {},
        //   'gate': 13,
        //   'usagePattern': 'single',
        //   'participantCalendar': []
        // },
        { 
          'id': 'EBIC5',
          'firstName': 'Shawn', 
          'lastName': 'Condor', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC7',
          'firstName': 'Scott', 
          'lastName': 'Jensen', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC8',
          'firstName': 'Loretta', 
          'lastName': 'Johnson', 
          'shareCount': 0.333,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        // { 
        //   'id': 'EBIC30',
        //   'firstName': 'Gary', 
        //   'lastName': 'Kinney', 
        //   'shareCount': 1,
        //   'turnLength': {},
        //   'gate': 13,
        //   'usagePattern': 'single',
        //   'participantCalendar': []
        // },
        { 
          'id': 'EBIC9',
          'firstName': 'Doug', 
          'lastName': 'Pearson', 
          'shareCount': 1, // using 0.5 from Donny Salazar
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        // { 
        //   'id': 'EBIC10',
        //   'firstName': 'Donny', 
        //   'lastName': 'Salazar', 
        //   'shareCount': 0.5,
        //   'turnLength': {},
        //   'gate': 13,
        //   'usagePattern': 'single',
        //   'participantCalendar': []
        // },
        { 
          'id': 'EBIC11',
          'firstName': 'Carolyn', 
          'lastName': 'Roseberry', 
          'shareCount': 0.75, // 0.5 from Kevin Moore
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC12',
          'firstName': 'Vivian', 
          'lastName': 'Rehm', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC13',
          'firstName': 'Craig', 
          'lastName': 'Jacobsen', 
          'shareCount': 1.5,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC14',
          'firstName': 'Sandra', 
          'lastName': 'Claridge', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC15',
          'firstName': 'Arlene', 
          'lastName': 'Frost', 
          'shareCount': 1, // 0.5 from Ida Frandsen, 0.5 Clark Williams
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        // { 
        //   'id': 'EBIC16',
        //   'firstName': 'Rylan', 
        //   'lastName': 'Barton', 
        //   'shareCount': 1,
        //   'turnLength': {},
        //   'gate': 13,
        //   'usagePattern': 'single',
        //   'participantCalendar': []
        // },
        // { 
        //   'id': 'EBIC19',
        //   'firstName': 'Pieper', 
        //   'lastName': 'Karl', 
        //   'shareCount': 2,
        //   'turnLength': {},
        //   'gate': 13,
        //   'usagePattern': 'single',
        //   'participantCalendar': []
        // },
        { 
          'id': 'EBIC18',
          'firstName': 'Ken', 
          'lastName': 'Jensen', 
          'shareCount': 1.5,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC17',
          'firstName': 'Brent', 
          'lastName': 'Cottle', 
          'shareCount': 2, // 2 from Elsinore Town
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC31',
          'firstName': 'Sam', 
          'lastName': 'Fulmer', 
          'shareCount': 1.5,
          'turnLength': {},
          'gate': 13,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC21',
          'firstName': 'Phillip/Jay', 
          'lastName': 'Johnson/Marquardson', 
          'shareCount': 3.75, // combined, 1.25 from Jay Marquardson
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC22',
          'firstName': 'Justin & Deanna', 
          'lastName': 'Holm', 
          'shareCount': 7.25,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC23',
          'firstName': 'Bryan & Jean', 
          'lastName': 'Sharp', 
          'shareCount': 1,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC24',
          'firstName': 'Beverly', 
          'lastName': 'Huntsman', 
          'shareCount': 0.5,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC25',
          'firstName': 'Randy & Carol', 
          'lastName': 'Howell', 
          'shareCount': 0.5,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC26',
          'firstName': 'Jason', 
          'lastName': 'Winn', 
          'shareCount': 0.5,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC27',
          'firstName': 'Dean & Cathy', 
          'lastName': 'Jensen', 
          'shareCount': 3, // 1, 2 from Elsinore Town
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC28',
          'firstName': 'Nicoline', 
          'lastName': 'Lee', 
          'shareCount': 0.5,
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
        { 
          'id': 'EBIC29',
          'firstName': 'James', 
          'lastName': 'Hansen', 
          'shareCount': 10.833, // 9.5 Self, 0.833 from Carla Gray, 0.5 from Pam Lee
          'turnLength': {},
          'gate': 14,
          'usagePattern': 'single',
          'participantCalendar': []
        },
      ]     
    }
  },
  provide() {
    return {
      gateData: this.gates,
      participantData: this.participants
    }
  },
  methods: {
    setUpGates() {
      for (let i = 0; i < this.gates.length; i++) {
        const targetGate = this.gates[i];
        const gateParticipants = this.getParticipantsByGate(targetGate.gate); // use cool function to get list

        // Set total shares for the gate based on regular ownership. This will fluctuate week to week.
        for (const pattern in targetGate.waterUsagePattern) {
          let shareTally = 0;

          gateParticipants.forEach(participant => {
            if (participant.usagePattern == 'single') {
              shareTally += participant.shareCount;
            } else {
              if (targetGate.waterUsagePattern[pattern].pattern == 'double') {
                shareTally += (participant.shareCount * 2);
              }
            }
            
          });

          targetGate.waterUsagePattern[pattern].totalShares = shareTally;
        }
        
        
        // Set share duration for the gate
        for (const pattern in targetGate.waterUsagePattern) {
          const rawDuration = targetGate.waterUsagePattern[pattern].runningTime / targetGate.waterUsagePattern[pattern].totalShares;
          // const roundedDuration = Math.floor(rawDuration / 5) * 5;
          const roundedDuration = rawDuration; // Remove rounding to get closer to correct end times.
          targetGate.waterUsagePattern[pattern].shareDuration = roundedDuration; 
        }
        
        
        // Set turn length for each participant based on share duration and usage type
        gateParticipants.forEach(participant => {
          let participantUsage = participant.usagePattern;
          let patternArray = targetGate.waterUsagePattern;

          patternArray.forEach((patternObj) => {
            if (patternObj.pattern === 'single') {
              if (participantUsage === 'single') {
                participant.turnLength.single = this.roundTime(participant.shareCount * patternObj.shareDuration);
              } else {
                participant.turnLength.single = 0;
              }
            } else {
              if (participantUsage === 'single') {
                participant.turnLength.double = this.roundTime(participant.shareCount * patternObj.shareDuration);
              } else {
                participant.turnLength.double = this.roundTime(participant.shareCount * patternObj.shareDuration) * 2;
              }
            }
          })
        });
      }
    },
    buildFullCalendars() {
      this.gates.forEach(theGate => {
        const targetGate = this.gates.find(item => item.gate === theGate.gate);
        const pickStartDate = targetGate.programStart;
        const startDate = dayjs(pickStartDate);
        const gateParticipants = this.getParticipantsByGate(targetGate.gate); // use cool function to get list
        let theWeek = startDate;

        for (let w = 0; w < targetGate.programDuration; w++) {
          let isDoubleWeek = false;
          
          // Override if gate is set to true to start it on a double week, then toggle
          if (targetGate.startsOnDouble == true) {
            isDoubleWeek = this.isEven(w);
          } else {
            isDoubleWeek = this.isOdd(w);
          }
          
          let theWeekEntry = { 
            id: targetGate.gate + '-' + theWeek.format('YY' + '-' + 'MM' + '-' + 'DD'),
            label: theWeek.format('MMM D' + ', ' + 'YYYY'),
            entries: []
          };
          let theTimer = dayjs(theWeek);

          // Build full calendar entries for the week and push to the week array
          gateParticipants.forEach(participant => {
            const theEntry = {}; 
            let theSingleTurnLength = participant.turnLength.single;     
            let theDoubleTurnLength = participant.turnLength.double;
            let hasTurnLength = false;
            
            theEntry.name = participant.firstName + " " + participant.lastName;

            if (
                isDoubleWeek === true && theDoubleTurnLength > 0 ||
                isDoubleWeek === false && theSingleTurnLength > 0
              ) {
              hasTurnLength = true;
            }
            
            if (hasTurnLength === true) {
              theEntry.start = theTimer.format('MMM DD hh' + ':' + 'mm A');
              if (isDoubleWeek === true) {
                theTimer = theTimer.add(theDoubleTurnLength, 'minute');
              } else {
                theTimer = theTimer.add(theSingleTurnLength, 'minute');
              }
              theEntry.end = theTimer.format('MMM DD hh' + ':' + 'mm A');
              theWeekEntry.entries.push(theEntry);
              participant.participantCalendar.push(theEntry);
            }
          });

          

          // Add the week array to the gate calendar object
          targetGate.gateCalendar.push(theWeekEntry);

          // Increment to the next starting period
          theWeek = theWeek.add(7, 'day').add(12, 'hour');
          
        }
      });
    },
    isEven(num) {
      // returns 
      return num % 2 == 0;
    },
    isOdd(num) {
      return num % 2 != 0;
    },
    roundTime(rawTime) {
      return Math.round(rawTime / 5) * 5;
    },
    getParticipantsByGate(gateNum) {
      const gateParticipants = this.participants.filter(member => member.gate === gateNum);
      return gateParticipants;
    },
    getGateCalendar(gateNum) {
      const targetGate = this.gates.find(theGate => theGate.gate === gateNum );
      return targetGate.gateCalendar;
    }
  },
  mounted() {
    this.setUpGates(); // Calculates share duration and assigns times to everyone
    this.buildFullCalendars(); // Calculates full calendars for all gates

    // Turn on to log gate data for setup
    console.log(this.gates);
    console.log(this.participants);
  }
}
</script>
  
<style>
:root {
  --white: #ffffff;
  --black: #000000;
  --blue-100: #308FBF;
  --blue-500: #004A6F;
  --green-100: #30BF6C;
  --red-100: #BF4830;
}

html, html * {
  box-sizing: border-box;
}

body {
  padding: 20px;
  font-family: 'noto-sans', helvetica, arial, sans-serif;
  max-width: 840px;
  margin: 0 auto;
}

h2 {
  color: var(--blue-500);
  font-weight: 700;
  font-size: 21.6px;
}

.button {
  display: inline-flex;
  justify-content: center;
  background-color: var(--white);
  border: 2px solid var(--blue-100);
  color: var(--blue-500);
  padding: 15px 20px;
  text-decoration: none;
  border-radius: 9999px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  transition: all 200ms ease;
}

.button:hover {
  background-color: var(--blue-500);
  color: var(--white);
}

.link-back {
  font-weight: 700;
  font-size: 16px;
  color: var(--blue-100);
  text-decoration: none;
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
  background-color: var(--white);
  border-width: 0 0 2px 0;
  border-color: var(--blue-100);
  margin-bottom: 40px;
  display: inline-block;
  cursor: pointer;
}
</style>;